import { Link, NavLink, useLocation } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import heroTriangle from './../../assets/images/hero-animation-triangle.svg';
import heroWhiteCircle from './../../assets/images/hero-animation-circle.svg';
import heroBlackCircle from './../../assets/images/hero-animation-black-circle.png';
import heroSquare from './../../assets/images/hero-animation-square.svg';
import heroRectangle from './../../assets/images/hero-animation-rounded-rectangle.svg';
import heroTakeawaysCircle from './../../assets/images/hero-takeaways-circle.svg';
import heroTakeawaysSquare from './../../assets/images/hero-takeaways-square.svg';
import heroTakeawaysPinkTriangle from './../../assets/images/hero-takeaways-pink-triangle.svg';
import heroTakeawaysBlueTriangle from './../../assets/images/hero-takeaways-blue-triangle.svg';
import heroTakeawaysRoundedRectangle from './../../assets/images/hero-takeaways-rounded-rectangle.svg';
import './subsection-header.scss';
import { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';

export default function SubsectionHeader(props) {
  const {show = true} = props;

  const url = useLocation();

  const formattedCurrentSection = props.currentSection.toLowerCase();
  
  /*const heroRef = useRef();
  const [offsetHeight, setOffsetHeight] = useState(0);

  console.log(props.headerOffset);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top - window.pageYOffset;
    //const yCoordinate = window.pageYOffset;
    console.log(yCoordinate);
    console.log(window.pageYOffset);
    const yOffset = offsetHeight;
   // const yOffset = -90; 
    //window.scrollTo({ top: yCoordinate - props.headerOffset, behavior: 'smooth' }); 
  }*/

  useEffect(() => {

    //const yOffsetHeight = heroRef.current.offsetHeight - props.headerOffset;
    //console.log(yOffsetHeight);
    //setOffsetHeight(props.headerOffset);
    //console.log(offsetHeight);

    // Financial Hero Animation. The team wanted them to be different per section.
    if (props.currentSection === "Financial") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-triangle", { x: -337, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-1", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-2", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { x: 723, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 91, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-square", { y: 91, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-triangle", { x: -337, duration: 1 }, "firstShapeTransition")
        .to(".circle-1", { x: -403, duration: 1 }, "firstShapeTransition")
        .to(".circle-2", { x: -403, duration: 1 }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { x: 723, duration: 1 }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 91, duration: 1 }, "firstShapeTransition")
        .to(".hero-square", { y: 91, duration: 1 }, "firstShapeTransition")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-triangle", { y: -180, duration: 1 }, "secondShapeTransition")
        .to(".circle-1", { x: -574, duration: 1 }, "secondShapeTransition")
        .to(".circle-2", { y: -172, duration: 1 }, "secondShapeTransition")
        .addLabel("thirdShapeTransition", "+=1")
        .to(".hero-square", { x: 339, duration: 1 }, "thirdShapeTransition")
        .to(".hero-triangle", { y: 0, duration: 1 }, "thirdShapeTransition")
        .to(".circle-1", { y: 172, duration: 1 }, "thirdShapeTransition")
        .to(".circle-2", { x: -574, duration: 1 }, "thirdShapeTransition")
        .addLabel("fourthShapeTransition", "+=1")
        .to(".circle-1", { x: -403, duration: 1 }, "fourthShapeTransition")
        .to(".circle-2", { y: 0, duration: 1 }, "fourthShapeTransition")
        .addLabel("fifthShapeTransition", "+=1")
        .to(".hero-square", { x: 0, duration: 1 }, "fifthShapeTransition")
        .to(".circle-1", { y: 0, duration: 1 }, "fifthShapeTransition")
        .to(".circle-2", { x: -403, duration: 1 }, "fifthShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

    // Retail Hero Animation. 
    if (props.currentSection === "Retail") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-triangle", { y: 91, x: -167, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-1", { y: 430, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-2", { y: 430, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { x: 723, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 434, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-square", { x: 340, y: 91, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-triangle", { y: -100, x: -337, duration: 1 }, "firstShapeTransition")
        .to(".circle-1", { y: 257, duration: 1 }, "firstShapeTransition")
        .to(".circle-2", { x: -170, duration: 1 }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { x: 723, duration: 1 }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 91, duration: 1 }, "firstShapeTransition")
        .to(".hero-square", { y: 0, duration: 1 }, "firstShapeTransition")
        .to(".hero-square", { x: 170, duration: 1 }, "firstShapeTransition+=1")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-square", { y: 91, duration: 1 }, "secondShapeTransition")
        .to(".hero-triangle", { y: 90, duration: 1 }, "secondShapeTransition")
        .to(".circle-2", { y: 600, duration: 1 }, "secondShapeTransition")
        .to(".circle-1", { x: -170, duration: 1 }, "secondShapeTransition")
        .addLabel("thirdShapeTransition", "+=1")
        .to(".hero-square", { x: 510, duration: 1 }, "thirdShapeTransition")
        .to(".hero-triangle", { y: 91, x: -167, duration: 1 }, "thirdShapeTransition")
        .to(".circle-2", { x: 0, duration: 1 }, "thirdShapeTransition")
        .to(".circle-1", { y: 427, duration: 1 }, "thirdShapeTransition")
        .addLabel("fourthShapeTransition", "+=1")
        .to(".circle-2", { y: 433, duration: 1 }, "fourthShapeTransition")
        .to(".circle-1", { x: 0, duration: 1 }, "fourthShapeTransition")
        .addLabel("fifthShapeTransition", "+=1")
        .to(".hero-square", { x: 340, duration: 1 }, "fifthShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

    // CPG Hero Animation. 
    if (props.currentSection === "CPG") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-triangle", { x: -239, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-1", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-2", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { y: -168, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 92, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-square", { x: 382, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-triangle", { y: -180, duration: 1 }, "firstShapeTransition")
        .to(".circle-2", { x: -575, duration: 1 }, "firstShapeTransition")
        .to(".circle-1", { y: 172, duration: 1 }, "firstShapeTransition")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-square", { x: 721, duration: 1 }, "secondShapeTransition")
        .to(".circle-2", { y: -171, duration: 1 }, "secondShapeTransition")
        .to(".circle-1", { x: -574, duration: 1 }, "secondShapeTransition")
        .addLabel("thirdShapeTransition", "+=1")
        .to(".hero-square", { x: 382, duration: 1 }, "thirdShapeTransition")
        .to(".hero-triangle", { y: 0, duration: 1 }, "thirdShapeTransition")
        .to(".circle-2", { y: 0, duration: 1 }, "thirdShapeTransition")
        .to(".circle-1", { x: -403, duration: 1 }, "thirdShapeTransition")
        .addLabel("fourthShapeTransition", "+=1")
        .to(".circle-2", { x: -403, duration: 1 }, "fourthShapeTransition")
        .to(".circle-1", { y: 0, duration: 1 }, "fourthShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

    // Insurance Hero Animation. 
    if (props.currentSection === "Insurance") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-triangle", { x: -239, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-1", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-2", { x: -403, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { y: -168, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 92, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-square", { y: 91, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-triangle", { y: -100, duration: 1 }, "firstShapeTransition")
        .to(".circle-2", { x: -575, duration: 1 }, "firstShapeTransition")
        .to(".circle-1", { y: 172, duration: 1 }, "firstShapeTransition")
        .to(".hero-square", { x: 0, duration: 0 }, "firstShapeTransition")
        .to(".hero-square", { y: -90, duration: 0.5 }, "firstShapeTransition")
        .to(".hero-square", { x: 170, duration: 0 }, "firstShapeTransition+=0.5")
        .to(".hero-square", { y: 90, duration: 0.5 }, "firstShapeTransition+=0.5")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-square", { y: -90, duration: 0.5 }, "secondShapeTransition")
        .to(".hero-square", { x: 0, duration: 0 }, "secondShapeTransition+=0.5")
        .to(".hero-square", { y: 90, duration: 0.5 }, "secondShapeTransition+=0.5")
        .to(".circle-2", { x: -403, duration: 1 }, "secondShapeTransition")
        .to(".circle-1", { y: 0, duration: 1 }, "secondShapeTransition")
        .to(".hero-triangle", { y: 0, duration: 1 }, "secondShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

    // Health Hero Animation. 
    if (props.currentSection === "Health") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-triangle", { x: -239, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-1", { y: -333, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".circle-2", { y: -337, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-rounded-rectangle", { y: -168, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-black-circle", { y: 92, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-square", { y: 91, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-square", { x: 0, duration: 0 }, "firstShapeTransition")
        .to(".hero-triangle", { y: -100, duration: 1 }, "firstShapeTransition")
        .to(".circle-2", { x: -172, duration: 1 }, "firstShapeTransition")
        .to(".circle-1", { y: -163, duration: 1 }, "firstShapeTransition")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-black-circle", { y: 260, duration: 1, ease: "power2" }, "secondShapeTransition")
        .to(".circle-2", { x: 0, duration: 1 }, "secondShapeTransition")
        .to(".circle-1", { y: -332, duration: 1 }, "secondShapeTransition")
        .to(".hero-triangle", { y: 0, duration: 1 }, "secondShapeTransition")
        .addLabel("thirdShapeTransition", "+=1")
        .to(".circle-2", { x: -172, duration: 1 }, "thirdShapeTransition")
        .to(".circle-1", { y: -163, duration: 1 }, "thirdShapeTransition")
        .to(".hero-square", { y: -90, duration: 0.5 }, "fourthShapeTransition")
        .to(".hero-square", { x: 170, duration: 0 }, "fourthShapeTransition+=0.5")
        .to(".hero-square", { y: 90, duration: 0.5 }, "fourthShapeTransition+=0.5")
        .to(".hero-triangle", { y: -100, duration: 1 }, "thirdShapeTransition")
        .addLabel("fourthShapeTransition", "+=1")
        .to(".circle-2", { x: 0, duration: 1 }, "fourthShapeTransition")
        .to(".circle-1", { y: -332, duration: 1 }, "fourthShapeTransition")
        .to(".hero-square", { y: -90, duration: 0.5 }, "fourthShapeTransition")
        .to(".hero-square", { x: 0, duration: 0 }, "fourthShapeTransition+=0.5")
        .to(".hero-square", { y: 90, duration: 0.5 }, "fourthShapeTransition+=0.5")
        .to(".hero-black-circle", { y: 92, duration: 1, ease: "power2" }, "fourthShapeTransition")
        .to(".hero-triangle", { y: 0, duration: 1 }, "fourthShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

    // Key Takeaways Hero Animation. 
    if (props.currentSection === "Takeaways") {
      function intro() {
        var tl = gsap.timeline();
        tl
        .to(".hero-takeaways-pink-triangle", { x: -367, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-blue-triangle", { x: -284, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-circle", { y: 128, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-rounded-rectangle", { y: -81, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-square", { y: 128, duration: 1, ease: "power2" }, "firstShapeTransition")
        return tl;
      }

      function middle() {
        var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
        tl
        .addLabel("firstShapeTransition")
        .to(".hero-takeaways-rounded-rectangle", { x: 200, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-circle", { x: -128, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-square", { x: 128, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-pink-triangle", { y: 200, duration: 1, ease: "power2" }, "firstShapeTransition")
        .to(".hero-takeaways-blue-triangle", { y: 200, duration: 1, ease: "power2" }, "firstShapeTransition")
        .addLabel("secondShapeTransition", "+=1")
        .to(".hero-takeaways-pink-triangle", { y: 0, duration: 1, ease: "power2" }, "secondShapeTransition")
        .to(".hero-takeaways-blue-triangle", { y: 0, duration: 1, ease: "power2" }, "secondShapeTransition")
        .to(".hero-takeaways-circle", { x: -188, duration: 1, ease: "power2" }, "secondShapeTransition")
        .to(".hero-takeaways-square", { x: 0, duration: 1, ease: "power2" }, "secondShapeTransition")
        .addLabel("thirdShapeTransition", "+=1")
        .to(".hero-takeaways-pink-triangle", { y: 200, duration: 1, ease: "power2" }, "thirdShapeTransition")
        .to(".hero-takeaways-blue-triangle", { y: 200, duration: 1, ease: "power2" }, "thirdShapeTransition")
        .to(".hero-takeaways-rounded-rectangle", { x: 0, duration: 1, ease: "power2" }, "thirdShapeTransition")
        .addLabel("fourthShapeTransition", "+=1")
        .to(".hero-takeaways-pink-triangle", { y: 0, duration: 1, ease: "power2" }, "fourthShapeTransition")
        .to(".hero-takeaways-blue-triangle", { y: 0, duration: 1, ease: "power2" }, "fourthShapeTransition")
        .to(".hero-takeaways-circle", { x: 0, duration: 1, ease: "power2" }, "fourthShapeTransition")
        .to(".hero-takeaways-square", { x: 0, duration: 1, ease: "power2" }, "fourthShapeTransition")
        return tl;
      }

      // stitch them together in a master timeline...
      var master = gsap.timeline();
      master
        .add(intro())
        .add(middle()) 
      ;
    }

  }, []);

  useEffect(() => {
    if(window.location.hash) {
     window.history.replaceState("", document.title, window.location.pathname);
    }

    console.log(url.pathname);

  }, [url.pathname]);

  return (
    <>
      <div className="subsection-header">
        <div className="banner-area" title={props.heroAlt}>

          <div className="hero-animating-shapes">

            {props.currentSection === 'Takeaways' ?

              <>
              <div className="hero-takeaways-pink-triangle">
                <img src={heroTakeawaysPinkTriangle} alt="" />
              </div>
              <div className="hero-takeaways-blue-triangle">
                <img src={heroTakeawaysBlueTriangle} alt="" />
              </div>
              <div className="hero-takeaways-circle">
                <img src={heroTakeawaysCircle} alt="" />
              </div>
              <div className="hero-takeaways-square">
                <img src={heroTakeawaysSquare} alt="" />
              </div>
              <div className="hero-takeaways-rounded-rectangle">
                <img src={heroTakeawaysRoundedRectangle} alt="" />
              </div>

              </>

              :

              <>
              <div className="hero-triangle">
                <img src={heroTriangle} alt="" />
              </div>
              <div className="hero-white-circle circle-1">
                <img src={heroWhiteCircle} alt="" />
              </div>
              <div className="hero-white-circle circle-2">
                <img src={heroWhiteCircle} alt="" />
              </div>
              <div className="hero-black-circle">
                <img src={heroBlackCircle} alt="" />
              </div>
              <div className="hero-rounded-rectangle">
                <img src={heroRectangle} alt="" />
              </div>
              <div className="hero-square">
                <img src={heroSquare} alt="" />
              </div>
              </>

            }

           
          </div>

          <div className='banner-wrap'>
            <h1 dangerouslySetInnerHTML={{ __html: props.h1 }}></h1>
            <h2>{props.h2}<span className='sub-text'>{props.subtext}</span></h2>
          </div>
        </div>
        {show &&
          <div className='submenu-wrap'>
            <div id='subnav'></div>
            <ul className="subnav">
              <li><NavHashLink className={url.pathname =='/financial/' ? "active" : ""} activeClassName="active" to={'/' + formattedCurrentSection + '#subnav'} end>Usage</NavHashLink></li>
              <li><NavHashLink className={url.pathname =='/financial/planning/' ? "active" : ""} activeClassName="active" to={'/' + formattedCurrentSection + '/planning' + '#subnav'} end>Planning</NavHashLink></li>
              <li><NavHashLink className={url.pathname =='/financial/integration/' ? "active" : ""} activeClassName="active" to={'/' + formattedCurrentSection + '/integration' + '#subnav'} end>Integration</NavHashLink></li>
              <li><NavHashLink className={url.pathname =='/financial/metrics/' ? "active" : ""} activeClassName="active" to={'/' + formattedCurrentSection + '/metrics' + '#subnav'} end>Metrics</NavHashLink></li>
              <li><NavHashLink className={url.pathname =='/financial/future/' ? "active" : ""} activeClassName="active" to={'/' + formattedCurrentSection + '/future' + '#subnav'} end>Future</NavHashLink></li>
            </ul>
          </div>
          }
      </div>
    </>
  );
}
